import { render, staticRenderFns } from "./CategorizedListModule.vue?vue&type=template&id=29a9ad19"
import script from "./CategorizedListModule.vue?vue&type=script&lang=js"
export * from "./CategorizedListModule.vue?vue&type=script&lang=js"
import style0 from "./CategorizedListModule.vue?vue&type=style&index=0&id=29a9ad19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports